<script>
export default {
  name: 'Unauthorized'
}
</script>

<template>
  <div>
    <h1>Unauthorized</h1>
    <hr />
    <p>
      You do not have access to this system. If this is in error, please email
      accounts@arm.gov to get this corrected.
    </p>
  </div>
</template>
